/**
 * Feature flags convention: go/frontend-feature-flags
 */
import { CONTROL, NOT_ENROLLED, VARIATION } from '@atlassian/jira-common-util-get-experiment-group';
import { expValEquals } from '@atlassian/jira-feature-experiments';

import {
	ff,
	getFeatureFlagValue,
	getMultivariateFeatureFlag,
} from '@atlassian/jira-feature-flagging';
import {
	VARIANT_CONTEXTUAL,
	VARIANT_CONTEXTUAL_NOT_ENROLLED,
} from '@atlassian/jira-issue-view-common-constants/src/experiment-constants';
import { isInMentionsIndicatorExperimentCohort } from '@atlassian/jira-mentions-indicator';

// moptland start
export const isAllPerfFeatureFlagsEnabled = () =>
	ff('ken-100-add-all-featureflags-to-issue-view-performance-events_kmez7');

// moptland end

// mmondal start
export const isChildIssuePanelConfigurationEnabled = () =>
	ff('configurable-child-issues-panel_3ht06', false);
// mmondal end

// <ssaraswat>
export const isIssueViewCommentRender = () => ff('issue-comment-render_tt9jk');
export const isIssueViewCommentFetch = () => ff('issue-comment-fetch_9eeal');
export const isEcosystemLeftPanel = () => ff('ecosystem_content_panel_lhs_6eptr');
export const isQuickActionExperimentFF = () => ff('issue_view_quick_actions_revamp_l8mbx');
// </ssaraswat>

// <ugouhar>
export const isDataClassificationEnabled = () =>
	ff('jira-issue-history-data-classification_mhyjw', false);
// </ugouhar>

// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isModernGlobalIssueCreateTriggerLinkedIssueEnabled = () =>
	ff('create-linked-issues-trigger-point-issue-view', false);

// <ForgeSlot>

// <ACaySlot>
export const isIssueFetchEpicPrefetchedAGGQueryLoggingEnabled = () =>
	ff('issue.details.issue-fetch-epic-prefetched-agg-query-logging', false);
// </ACaySlot>

// <mklus>
export const isIssueViewActivityFeedUIFixesEnabled = () =>
	ff('jira-issue-view-activity-feed-ui-fixes', false);
// </mklus>

// <lli7>
export const isRelayCascadingSelectFieldIssueViewIntegrationEnabled = () =>
	ff('issue.details.relay-cascading-select-field-issue-view-layout-integration');
// </lli7>
// Rach slot
// start

// 1
// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isIssueViewMigratedStreamEnabled = () =>
	ff('issue.details.migration-migrated-stream', false);

// 2
// 3
export const isGiraAGGConsistencyCheckEnabled = () =>
	getMultivariateFeatureFlag('issue.details.gira-agg-consistency-check-master-flag', 'OLD', [
		'OLD',
		'NEW',
		'CHECK',
		'CHECK_RETURN_NEW',
	]) === 'CHECK';

// Rach slot

// @pierrelingat slot start
export const isJiraIssueViewEditorAIEnabled = () =>
	ff('issue.details.jira-issue-view-editor-ai_sozy', false);

export const isIssueViewAdminGlobalOptInAiEnabled = () =>
	ff('issue-view-admin-global-opt-in-ai', false);

export const isJiraIntelligentIssueBreakdownEnabled = () =>
	ff('jira-intelligent-issue-breakdown_18syl', false);

export const isJiraSmartSummaryPlatformEnabled = () =>
	ff('issue.details.jira-smart-summary-platform_0jta9', false);

export const isJiraAIWorkBreakdownOnboardingEnabled = () =>
	ff('jira-ai-work-breakdown-onboarding', false);

export const isIssueTypeSelectHierarchyFixEnabled = () =>
	ff('issue.details.issue-type-select-hierarchy-fix', false);

export const isShardAndRegionToSLOAnalyticsEnabled = () =>
	ff('issue.details.shard-and-region-to-slo-analytics', false);

export const isFeatureFlagsToSLOAnalyticsEnabled = () =>
	ff('issue.details.feature-flags-to-slo-analytics', false);
// @pierrelingat slot end

// @aimenhamed slot start
export const isJiraAiWorkBreakdownDisclaimerUpdateEnabled = () =>
	ff('jira-ai-work-breakdown-disclaimer-update', false);
// @aimenhamed slot end

// <rjiang slot>
// </rjiang>

// @wongben slot start
export const isA11yForIssueKeyStrikethroughEnabled = () =>
	ff('issue-view-a11y-for-issue-key-strikethrough_3xavq', false);

export const isIssueViewRemoveConnectOperationsFromCriticalFetchEnabled = () =>
	ff('issue-view-remove-connect-operations-from-critical-fetch_vtk4w');

// @wongben slot end

// SLOT START - media-feature-flags.js

// on cleanup, please remove from src/packages/issue/test-util/src/main.js also

export const isMediaInlineEnabled = () => ff('issue.details.media-inline', false);

// SLOT END

export const isTeamsCustomFieldTypeEnabled = () =>
	ff('jira.teams.enable-new-custom-field-types', false);

// <growth team experiment slot>
export const isInviteFromAssignEnabled = (): boolean =>
	getMultivariateFeatureFlag('invite.from.assign', NOT_ENROLLED, [
		CONTROL,
		NOT_ENROLLED,
		VARIATION,
	]) === VARIATION;

export const getInviteFromAssignModalCohort = () =>
	getMultivariateFeatureFlag('invite.from.assign.modal', 'not-enrolled', [
		'control',
		'not-enrolled',
		'variation',
	]);

export const isInviteFromAssignModalFeEnabled = () =>
	ff('invite.from.assign.modal.fe.event', false);

export const isFedRampCheckEnabled = () =>
	ff('confluence.frontend.growth.fedramp-check-isolation', false);
// </growth team experiment slot>

// <lchen2 slot>

export const isStoryPointAnalyticsEnabled = () =>
	ff('issue.detail.issue-view-story-point-field-type-analytics_n9ha6');

export const isTrelloCardIntegrationPatch = () => ff('trello.card.integration.patch', false);
export const isNewEditorAiFeedbackCollectorEnabled = () =>
	ff('issue.details.update-jira-editor-ai-feedback-collector_qv6kk');
// </lchen2>

// <ashukla2>
export const isIssueCommentsHardLimitsFlagEnabled = () =>
	ff('comment-limit-exceed-warning-flag_3rx53', false);

export const isIssueWorklogsHardLimitsFlagEnabled = () =>
	ff('worklog-limit-exceed-warning-flag_hh86h', false);

export const isIssueConfluenceLinksHardLimitsFlagEnabled = () =>
	ff('confluence-link-limit-exceed-warning-flag_1ycku', false);

export const isNotifyAdminModalHardLimitsEnabled = () => ff('hard-limits-modal-admin_wo9xn', false);

export const isSmartSummariesNewDisclaimerEnabled = () =>
	ff('smart-summaries-new-disclaimer_s7l2u', false);

// </ashukla2>

// <lcaseiro slot>
export const issueDetailsHardLimitsMilestone1Enabled = () =>
	ff('issue.details.hard-limits.milestone-1');

export const issueDetailsHardLimitsIssueRemoteLinkEnabled = () =>
	ff('issue.details.hard-limits.issue-remote-link');

export const issueDetailsHardLimitsIssueAttachmentsEnabled = () =>
	ff('issue.details.hard-limits.issue-attachments-limit');

export const issueDetailsHardLimitsIssueWeblinksEnabled = () =>
	ff('issue.details.hard-limits.issue-weblinks-limit');

// </lcaseiro>

// <ksayapina slot>
export const isChangeboardingForParentEnabled = () =>
	ff('parent-field-changeboarding_4ljdy', false);
// </ksayapina>

// <midrew slot>
// </midrew slot>

// <leoc>
export const isOptimisticWeblinksFixEnabled = () =>
	ff('issue.details.display-flag-on-optimistic-weblinks-error');
// </leoc>

export const getPerformanceTrackingConfiguration = () =>
	getFeatureFlagValue('issue.details.editor.performance-tracking', {});

export const getValidTransactionsTrackingConfiguration = ():
	| { samplingRate: number }
	| undefined => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const value = getFeatureFlagValue<any>('issue.details.editor.valid-transactions-tracking', {});

	// workaround as editor is interpreting an empty object as enabled: https://product-fabric.atlassian.net/browse/ED-12432
	const enabled = typeof value === 'object' && Object.keys(value).length;
	return enabled ? value : undefined;
};

export const isEditorUFOEnabled = () => ff('issue.details.editor.ufo', false);

export const getTTRSeverityTrackingConfiguration = () =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getFeatureFlagValue<any>('issue.details.renderer.ttr-severity-tracking', {});

export const getUnsupportedContentLevelsTrackingConfiguration = () =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	getFeatureFlagValue<any>('issue.details.renderer.unsupported-content-levels-tracking', {});

// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isSpecBasedValidatorEnabled = () => ff('issue.details.renderer.spec-based-validator');

// <dharnett>
// </dharnett1>
// </dharnett2>
// </dharnett3>
// </dharnett4>

// </dharnett5>
// </dharnett7>
// </dharnett8>
// </dharnett9>
// </dharnett10>
// </dharnett11>
// </dharnett12>
// </dharnett13>
// </dharnett>

// <gryffindor>
export const isModernGlobalIssueCreateTriggerEnabled = () =>
	ff('project.config.pce.modern.global-issue-create.trigger', false);

export const isCreateLinkedIssueTriggerPointEnabled = () =>
	ff('create-linked-issues-trigger-point-issue-view', false);

// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isModernGlobalSubtaskIssueCreateTriggerEnabled = () =>
	ff('project.config.pce.modern.global-subtask-issue-create-trigger', false);

export const isModernGICEnabledForSubtask = () =>
	isModernGlobalIssueCreateTriggerEnabled() && isModernGlobalSubtaskIssueCreateTriggerEnabled();
// </gryffindor>

// <proforma>
export const isProformaHarmonisationFFEnabled = () =>
	ff('proforma-harmonisation-main_ca6ff', false);
// </proforma>

// <mliang>
export const isHideEpicLinkFromIssueViewForEpicRenamingBetaEnabled = () =>
	ff('hide-epic-link-from-issue-view-for-epic-renaming-beta_r1g77', false);

export const isDisableEpicLinkAndParentLinkFieldsEnabled = () =>
	ff('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt', false);

export const isRequestIsDoneWhenRequestingParentCandidatesEnabled = () =>
	ff('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy', false);
// </mliang>

// <ksenia>
export const isRemoveParentLinkFromIssueViewEnabled = () =>
	ff('remove-parent-link-from-issue-view_4t7dy', false);

export const isParentInIssueViewEnabled = () => ff('parent-field-in-issue-view_x4zn4', false);

export const isIncrementPlanningM1Enabled = () =>
	ff('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1', false);
// </ksenia>

// <crobertson>

// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isSwitcherooRealtimeExposuresTestFlagEnabled = () =>
	ff('switcheroo-realtime-exposures-test-flag_648u4', false);

// </crobertson>

// <hgao slot>
export const isPlaceHolderTemplateE2EEnabled = () =>
	ff('jira.issue-view.placeholder-template-e2e-iteration', false);

export const isIssueViewEndUserRequestTrialEnabled = () =>
	ff('issue-view-placeholder-end-user-request-modal_myc7n', false);
// </hgao>

// <tchen3>
export const isCompalIssueActionsEnabled = () => ff('compal-issue-actions', false);

export const isCompalIssueActionsFollowUpImprovementsEnabled = () => () =>
	ff('compal-issue-actions-follow-up-improvements_y49xu', false);

export const isCompalIssueActionsVeryHighPriorityEnabled = () => () =>
	ff('compal-issue-actions-very-high-priority_f5w5r', false);
// </tchen3>

// <kye>
// </kye>

// <fcahyandi>
export const isSelectableFieldEditViewIntegrationEnabled = () =>
	ff('issue.details.follow-up-relay-multi-select-field-issue-view-integration', false);

export const isHistoryActivityFeedAttachmentUpdatesEnabled = () =>
	ff('jira-issue-view-activity-feed-syntax-value-updates', false);
// </fcahyandi>

// <yihao>

export const isRemoveIssueAttachmentPanelViewedEventEnabled = () =>
	ff('remove-issueattachmentpanel-viewed-event_w282l');

// </yihao>

// <phong>
export const isFetchingRequiredFieldOnRenderEnabled = () =>
	ff('issue-view-fetch-the-required-field-on-rendering_lgknh', false);

export const isJiraSmartSummaryOnboardingEnabled = () =>
	ff('jira-issue-view-smart-summary-onboarding_jmzm7', false);

export const isJiraSmartSummaryAIMateEndpointEnabled = () =>
	ff('issue.details-smart-summary-with-ai-mate_qqug7.', false);

export const isDefinitionCheckConfluenceAccessEnabled = () =>
	ff(
		'issue-view-disable-definition-feature-if-the-user-doesnt-have-confluence-access_inh6g',
		false,
	);

export const IsAIWorkBreakdownNewUiEnabled = () => ff('jira-ai-work-breakdown-new-ui_z0inn', false);
// </phong>

// <aakeroyd>
export const isStatusInGicEnabled = () => ff('issue.details.gic.add_status_field', false);
// </aakeroyd>

// <itsm-grimlock>
export const isJsmSmartRequestSummaryEnabled = () =>
	ff('enable-jsm-smart-request-summary_kva1r', false);
// </itsm-grimlock>

// <iyeskov>
// on cleanup, please remove from src/packages/issue/test-util/src/main.js also
export const isAltTextOnImagesEnabled = () => ff('editor.renderer-alt-text-on-images', false);

// </iyeskov>

// <lwon>
export const useM4LayoutDataInBentoConsistencyCheckValue = () =>
	getFeatureFlagValue(
		'project.config.pce.use-m4-issue-layout-data-in-bento.with-consistency-check',
		'OLD',
	);
// </lwon>

// <kye>
export const ISSUE_DETAILS_SORTING_PINNED_FIELDS = 'issue.details.sorting-pinned-fields' as const;
export const isSortingPinnedFieldsEnabled = () => ff('issue.details.sorting-pinned-fields', false);
// </kye>

// <sxu>
export const getEnableFlexibleBlockCardInIssueEditor = () =>
	ff('issue.details.editor.enable-flexible-block-card');
// </sxu>

// <cshen>
export const isTeamFieldInSubtasksEnabled = () =>
	ff('jira.frontend.ptc.team-field-in-subtasks', false);
// </cshen>

// <garuda> <psinghal>
// added an api call on page-load to fetch offeringCatalogueFeatures from monolith
export const isOfferingCatalogueFeaturesEnabled = () =>
	ff('offeringcataloguefeatures-resource-layer-in-frontend_o5pnu', false);
// </garuda> </psinghal>

// <ptatarenko>
// enables sending analytics event with renderer specific tti measurement
// please do not cleanup, this feature flag is meant to be rolled out permanently just for a fraction of users
export const isRendererTtiTrackingEnabled = (): boolean =>
	ff('issue.details.renderer.tti-tracking', false);

// <ptatarenko>

// <rnguyen>
export const isPriorityFieldTooltipEnabled = (): boolean =>
	ff('sea-2830-improve-accessibility-of-priority-field-in-backlog-card_k53tq', false);
// </rnguyen>

// <jsmTimeline>
export const isJsmTimelineEnabled = (): boolean => ff('jsm-timelines-phase-2_70gja', false);

// <jsmTimeline>

// <jsm-nebula>
export const isCannedResponseFFEnabled = () => ff('jsm-canned-response', false);

export const isSignatureCrFFEnabled = () => ff('jsm-agent-signature-cr-enabled', false);
// </jsm-nebula>

// <asingh16>
export const isRespondersFieldAvailableInAllProjectsEnabled = () =>
	ff('responders-field-in-all-projects-issues-ui', false);
// </asingh16>

// <knaithani>
export const isEcClientEnabled = () => {
	const experiences: string = getFeatureFlagValue<string>(
		'odin.ec.client.integration.issueview',
		'',
	);

	return experiences.length > 0;
};

// </knaithani>

// <asharma9>
export const isOverrideCreationDateEnabled = () =>
	ff('override-date-for-attachment-timestamp-in-film-strip_ymajc');

export const isDeleteissueViewMetricsEnabled = () =>
	ff('metric-for-issue-delete-inside-issue-view_baxre');

// </asharma9>

// <ajamuar>
export const is4xxRequestsIgnoreEnabled = () => ff('ken-429-restrict-4xx-error_vi8v7', false);
export const isMiddleClickFixEnabled = () =>
	ff('ken-524-fix-middle-click-issue-for-linked-issues_x1hgl', false);
export const isLogForMissingProjectTypeEnabled = () =>
	ff('ken-432-missing-project-key-log_hr7zv', false);
// </ajamuar>

// <qzeng>
// </qzeng>

// <gchan3>
export const isGiraAGGIsArchivedEnabled = () => {
	const featureFlagValue = getMultivariateFeatureFlag(
		'issue.details.gira-agg-migration-isarchived',
		'OLD',
		['OLD', 'NEW', 'CHECK', 'CHECK_RETURN_NEW'],
	);

	return (
		featureFlagValue === 'NEW' ||
		featureFlagValue === 'CHECK_RETURN_NEW' ||
		featureFlagValue === 'CHECK'
	);
};
// </gchan3>

// </ssharma9>
export const isArchivedIssuesPageLinkEnabled = () => ff('enable-archived-issues-page-link', false);
// </ssharma9>

// <mbiniek>
export const isBM3EmitOnRafTopExperiencesEnabled = () =>
	ff('bm3.emit-on-raf.top-experiences', false);
// </mbiniek>

// <ttkachuk>
export const isCustomMessageForLinkingWithoutPermissionsEnabled = () =>
	ff('issue.details.custom-message-for-linking-with-no-permissions_k7qsn', false);

export const isSearchByEmailInMultiselectUserPickerEnabled = () =>
	ff('issue-view.enable-search-by-email-in-multiselect-user-picker-field', false);

export const isRelayReleaseVersionFieldIssueViewIntegrationEnabled = () =>
	ff('issue.details.relay-release-version-field-issue-view-integration', false);

export const isAsyncFieldOptionsTechDebtEnabled = () =>
	ff('issue.details.async-field-options-tech-debt', false);
// </ttkachuk>

// <jsm-shield>
export const isJsmFixIncompatibleRequestTypeInconsistenciesEnabled = () =>
	ff('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
// </jsm-shield>

// <myadamreddy>
// </myadamreddy>

// <jcastillo>
export const PlaceHolderTemplateFlags = {
	CROSS_FLOW: 'jira.issue-view.placeholder-template-cross-flow',
} as const;

export type PlaceHolderTemplateFlags =
	(typeof PlaceHolderTemplateFlags)[keyof typeof PlaceHolderTemplateFlags];

export const getPlaceHolderTemplateVariant = (experiment: PlaceHolderTemplateFlags): string =>
	experiment
		? getMultivariateFeatureFlag(experiment, NOT_ENROLLED, [
				VARIANT_CONTEXTUAL,
				VARIANT_CONTEXTUAL_NOT_ENROLLED,
				CONTROL,
				NOT_ENROLLED,
			])
		: NOT_ENROLLED;

// Whether the user is in the experiment for the dummy link (control or variant-contextual)
export const isConfluencePageDummyLinkExperiment = () =>
	[CONTROL, VARIANT_CONTEXTUAL].includes(
		getPlaceHolderTemplateVariant(PlaceHolderTemplateFlags.CROSS_FLOW),
	);

// Whether the user is in the dummy link variant
export const isConfluencePageDummyLinkEnabled = (experiment: PlaceHolderTemplateFlags): boolean =>
	getPlaceHolderTemplateVariant(experiment) === VARIANT_CONTEXTUAL;
// </jcastillo>

// <rliang>
// </rliang>

// <cturner>
export const isStopLoadingFieldConfigTwiceEnabled = () =>
	ff('jracloud-81255-stop-loading-field-config-twice_jfdek', false);
// </cturner>

// <gmountakis>
export const isNonCriticalGiraQueryExperienceTrackingEnabled = () =>
	ff('issue.details.non-critical-gira-query-experience-tracking', false);
// </gmountakis>

// <mrogulska>
// </mrogulska>

// <dboyd>
export const isFilterIssueChangedEvents = () =>
	ff('filter-issue-changed-connect-app-events-to-non-dialogs');
// </dboyd>

// <pravliv>

// </pravliv>

// <pracki>
export const isJiraForgeExtensionChangesForAegisEnabled = () =>
	ff('arken-1053-jira-forge-extension-changes-for-aegis_aws9x');
// </pracki>

// <vpetrychuk>
export const isDisableUnneededForgeMetricsEnabled = () => ff('remove-invalid-forge-metrics_n3ddj');

export const isAnotherExtensionContextForForgeBackgroundScriptsEnabled = () =>
	ff('change-the-way-we-get-project-context-for-forge-background-scripts_smqab');

export const isForgeExtensionMetricsFixEnabled = () => ff('fix-forge-extension-metrics_nkeqx');
// </vpetrychuk>

// <mhanna>
export const isCompassComponentsEnabled = () =>
	ff('compass-components-in-jira-components_xw42u', false);
// </mhanna>

// <itsm-agni>
export const isConferenceCallFieldHidden = () => ff('hide-icc-for-all-users_avyh5', false);
// <itsm-agni>

// <ngregory2>
export const isIssueLinkLimitEnabled = () =>
	ff('issue.details.issue-link-limit-exceed-warning-flag');
// </ngregory2>

// <pjerome>
export const isCreateConfluencePagesEnabled = () =>
	ff('platform.embedded-confluence.jira-issue.create-confluence-pages', false);
// <pjerome>

// <knaithani>
// </knaithani>

// <ptatarenko>
// Optimises editor on change handlers calls to improve typing performance
export const isOptimiseEditorOnchangeCallsEnabled = (): boolean =>
	ff('issue-details-optimise-editor-onchange-calls_bb4fq', false);
// <ptatarenko>

// <lward3>
export const isMentionsAnalyticsEnabled = () =>
	ff('sea-2350-analytics-for-mentions-in-board-and-backlog_2gkji');
// </lward3>

// <plai>
export const isNewLinkPickerEnabled = () =>
	ff('platform.linking-platform.link-picker_tgrho', false);
// </plai>

// <bcho>
export const isTraceIdForRelayErrorsEnabled = () =>
	ff('issue.view-add-traceids-to-issue-view-relay-errors_vm8h2');
// </bcho>

// <mdao>
export const getJiraIssuesDatasourceEnabled = () =>
	ff('platform.linking-platform.datasource-jira_issues', false);
// </mdao>

// <mdao>
export const shouldUseNewEditorCardProvider = () =>
	ff('platform.linking-platform.use-new-editor-card-provider', false);
// </mdao>

// <lward3>
export const isMentionsIndicatorEnabled = () => isInMentionsIndicatorExperimentCohort();
// </lward3>

// <kmaharjan4>
export const isDevOpsAppRecommenderEnabled = () =>
	ff('devops_app_recommendation_on_link_paste', false) &&
	expValEquals('devops_app_recommendation_on_link_paste', 'cohort', 'variation');
// </kmaharjan4>

// <tsirisongkol>
export const isIssueViewRemoveEcosystemBackgroundScriptsFromTTIEnabled = () =>
	ff('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on');
// </tsirisongkol>

// <ayeh>
export const isIssueDescriptionReadingAidEnabled = () =>
	ff('feature.reading-aid-in-issue-description', false);
// </ayeh>

// <sluu>
export const isIssueDescriptionAcronymsHighlightEnabled = () =>
	ff('jira-reading-aid-acronyms-highlight_3hr5i');

// </sluu>

// <tsirisongkol>
export const isIssueViewUnlinkGlancesFieldFromUi = () =>
	ff('issue-view-unlink-glancefield-from-ui_8a5yg');
// </tsirisongkol>

// <tsirisongkol>
export const isIssueViewRemoveGlancesFieldFromQuery = () =>
	ff('issue-view-remove-glancesfield-from-query_fyj0g');
// </tsirisongkol>

// <tsirisongkol>
export const isIssueViewImplementDeadGlancesFieldQuery = () =>
	ff('implement-dead-glancesfield-query_f71sc');
// </tsirisongkol>

// <asheel>
export const isAggMigrationAttachmentsEnabled = () =>
	ff('issue.details.gira-agg-migration-attachments_ecebe', false);
// </asheel>

// <gdeng>
export const isIssueViewWhiteboardsStandaloneEnabled = () =>
	ff('jira-issue-view-whiteboards-standalone', false);
// </gdeng>

// <a11y-jira-cloud>
export const isDynamicEditButtonLabelEnabled = () =>
	ff('a11y-jira-team-enable-dynamic-edit-button-label-for-issue-field_mpv9f', false);
// </a11y-jira-cloud>

// <tnienhouse>
export const isNinColumnResizingEnabled = () => ff('nin-resizable-columns_8z4eo');
// </tnienhouse>

// <skashyap>
export const isEmbeddedConfluenceIssueViewCrossJoinEnabled = () =>
	ff('platform_embed-conf_jira-issue_create_cross-join', false);
// </skashyap>

// <jbouzi>
export const isEmbeddedConfluenceIssueLinkedPageCrossJoinEnabled = () =>
	ff('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);
// </jbouzi>

// <cdeyoung>
export const isEmbeddedConfluenceIssueViewDeferSpaceSelectionEnabled = () =>
	ff('platform_embed-conf_jira-issue_co-use', false);
// </cdeyoung>

// <ninglis>
export const isWorkflowDataServiceHookEnabled = () =>
	ff('use-view-workflow-service-hook_8y6bk', false);
// </ninglis>

// <tsirisongkol>
export const isIssueViewRemoveEcosystemActivityPanelsFromTTIEnabled = () =>
	ff('issue-view-remove-activitypanels-from-critical-fetch_43ozj');
// </tsirisongkol>

// <csowden>
export const isGoalsFieldEnabledInIssueView = () =>
	ff('hrz-716-integrate-goal-picker-into-issue-view', false);
// </csowden>

// <aullal>
export const isTokensAndStyledComponentsMigrationEnabled = () =>
	ff('im-tokens-and-styled-components-migration_qpsld', false);
// <aullal>

// <rkumar8>
export const isIssueArchivalFeatureEnabled = () => ff('issue-unarchival_wdpb9', false);
// </rkumar8>

// <sbackler>
export const isIssueDateFieldSavedOnChange = () =>
	ff('teamcamp.confirm-issue-date-field-onchange-instead-of-onblur');
// </sbackler>

// <msuri>
export const isSentimentFieldEnabled = () => ff('jsm-sentiment-analysis_1dage', false);
// </msuri>

// <msuri>
export const isSentimentCustomFieldEnabled = () => ff('sentiment-custom-field', false);
// </msuri>

// <gordian>
export const isIssueExportControlEnabled = () => ff('dlp-gordian-enabled', false);
// </gordian>

// <kenji>
export const isIssueViewClassificationLevelEditabilityEnabled = () =>
	ff('issue-view-classification-level-editability_88zal', false);
// </kenji>

// <dvedi>
export const isDeleteLinkedIssueSLOEnabled = () =>
	ff('analytics_event_for_deletion_of_linked_issue_1ufi8', false);
// </dvedi>

// <smalviya>
export const isFixForJracloud82128Enabled = () => ff('fix-for-jracloud-82128_379yp', false);
// </smalviya>

// <jkalyan>
export const isCompalParentStatusCategoryIdEnabled = () =>
	ff('compal-issue-actions-parent-statuscategoryid_s2esc', false);
// </jkalyan>

// <ragarwal>
export const isJSMRestrictInternalCommentVisibilityEnabled = () =>
	ff('jsm-restrict-internal-comment-visibility', false);
// </ragarwal>

// <ninglis>
export const isIssueViewFitAndFinishM2Enabled = () =>
	ff('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);
// </ninglis>

// <dxu>
export const aggUseIsEditableInViewFlag = () =>
	ff('jiv-17158-agg-use-iseditableinview_8nogh', false);
// </dxu>

// mkulinski
export const isLinkedPagesBugFixEnabled = () => ff('linked-pages-embedded-bug-fix', false);
// mkulinski

// <yvovk>
export const isUIMCascadingSelectFieldEnablead = () =>
	ff('uim-cascading-select-field-support-gic_h1cda', false);
// <yvovk>

export const sprintFieldLongTextFixFlag = () => ff('sprint-field-long-text-bug_fo95j', false);
export const selectableFieldEditViewReplaceSelectWithFooter = () =>
	ff('selectable-field-edit-view-replace-select-with-footer_301u0', false);
// ddhanda

// mhermon
export const isAIUpsellPremiumTrailEnabled = () =>
	ff('jsw-premium-edition-eval-admin-ai-upsell_djht5', false);
// mhermon

// <clawu>
export const isEmbeddedConfluenceCreateContentCrossFlowEnabled = () =>
	ff('platform.embedded-confluence.jira-issue.create-confluence-content-crossflow', false);
// </clawu>

// <acherk>
export const isRendererDefaultSmartLinksValueEnabled = () =>
	ff('platform.linking-platform.jira-renderer-use-default-smartlinks-value', false);
export const isHoverCardAISummariesEnabled = () =>
	ff('platform.linking-platform.smart-card.hover-card-ai-summaries', false);
// </acherk>

// <spanchenko>
export const isAffectsVersionsFieldSupportForIVEnabled = () =>
	ff('forge-ui-modifications-affects-versions-field-support-iv_ff6mj', false);
// </spanchenko>

// aboutinflegel
export const isIssueViewNudgeExperimentEnabled = () =>
	ff('jsw.xflow.issue-view-nudge-experiment', false);
// aboutinflegel

// <jthai>
export const isApprovalsGlancePanelToCollapsibleContextGroupEnabled = () =>
	ff('convert-approvals-glance-to-collapsible-context-group_gqbgz', false);
// </jthai>

// <pjerome>
export const isConfluenceIntegrationsAdminControlsEnabled = () =>
	ff('confluence-admin-product-controls', false);
// </pjerome>

// vyakimenko
export const isCascadingSelectSupportForUIMEnabled = () =>
	ff('jsw.xflow.issue-view-nudge-experiment', false);
// vyakimenko

export const isWhiteboardStandaloneEnabled = () =>
	ff('jira-issue-view-whiteboards-standalone', false);

export const isFitAndFinishFullPageMilestone2 = () =>
	ff('issue-view-fit-and-finish-full-page-milestone2_ebk0i', false);

export const isCrossJoinContentPreviewEnabled = () =>
	ff('platform.embedded-confluence.jira-issue.linked-page-cross-join', false);

// bjayaramareddy
export const isHandleIssueCommentsEmptyEnabled = () =>
	ff('catch-issue-comments-empty-response-errors_o2gkc', false);

export const isHideLinkedIssueKeyForNonAuthorisesEnabled = () =>
	ff('hide-issue-key-when-linked-issue-has-no-access_8nb8t');
// bjayaramareddy

// <smalviya>
export const removeAllMentionsOfNewIssueView = () =>
	ff('remove-all-mentions-of-new-issue-view_unq0c', false);
// </smalviya>

// <jchau>
export const isReactReduxV8Upgrade = () => ff('jff.magma.react-redux-upgrade_53sr4', false);
// <jchau>

// <emoore>
export const isAvoidProjectRedirectFromIssueViewEnabled = () =>
	ff('jsw.perf.navigation.avoid-redirect-from-issue-view_iv5hd', false);
// </emoore>

// lmuller
export const isCMDBAttributeIdRemoved = () =>
	ff('assets-rearch-deprecate-attribute-value-id_ykukg', false);
// lmuller

// mawad
export const isExtraPaddingOnIssueActionButtonsEnabled = () =>
	ff('fix-narrow-button-spacing-on-issue-actions_icmq8', false);
// mawad

// jpark3
export const isBentoViewModeRefactor = () => ff('refactor-bento-view-mode-logic', false);
// jpark3

// <sms2>
export const is3pIssueWatchNudgeEnabled = () =>
	ff('third_party_app_nudge_on_issues_watch', false) &&
	expValEquals('third_party_app_nudge_on_issues_watch', 'cohort', 'variation');
// </sms2>

// <skashyap>
export const isLinkedMentionedRestrictedPageOnClickEnabled = () =>
	ff('linked_mentioned_pages_handle_restricted_page_on_click', false);
// </skashyap>

// <ezhang3>
export const isAddCommentScreenAnalyticsEnabled = () => ff('jira.onboarding.kuro-5895', false);
// </ezhang3>

// <alaktionova>
export const isJPDPanelEnabled = () => ff('polaris.jpd-panel-in-issue-view', false);
// </alaktionova>
